import React, { useEffect, useRef } from 'react'
import USTemplateDefault from 'src/components/template/us'
import styled from 'styled-components'
import { videos } from 'src/constants/videos'
import { sportIds, leagueIds } from 'src/constants/personalizationIds'
import FuboFreeTemplate from 'src/components/template/fubofree'
import { useCheckFanduelRSN } from 'src/modules/hooks/useCheckFanduelRSN'
import { fanduelSportsNetworkFAQs } from 'src/constants/faqs'
import { devicePosters } from 'src/constants'
import { useCountdownTest } from 'src/modules/hooks/useCountdownTest'
import { WEB_MARKETING_NHL_COUNTDOWN_TIMER } from 'src/modules/reducers/cohorts/constants'
import { fireUIRenderEvent } from 'src/modules/analytics/v3'
import { useSelector } from 'react-redux'
import { selectStateForProtobuf } from 'src/modules/reducers'
import { selectAnalyticsReady } from 'src/modules/reducers/analytics'

const BallySportsNHL = (props) => {
  const { showFDPlanCards, rsnData } = useCheckFanduelRSN({ sportType: 'nhl' })
  const stateForProtobuf = useSelector(selectStateForProtobuf)
  const isAnalyticsReady = useSelector(selectAnalyticsReady)
  const isEventSent = useRef(false)

  const { matchCountdownTimer, matchTitle, teamMatches, isCountdownNoSubtitle, isCountdown } =
    useCountdownTest(props.teamId, WEB_MARKETING_NHL_COUNTDOWN_TIMER)

  useEffect(() => {
    if (!isEventSent.current && isAnalyticsReady && teamMatches.length) {
      fireUIRenderEvent(
        {
          component: 'countdown_timer_has_game',
        },
        stateForProtobuf
      )
      isEventSent.current = true
    }
  }, [isAnalyticsReady, teamMatches.length])

  const commonProps = {
    location: props.location,
    lang: 'en',
    market: 'us',
    video: props.poster ? null : props.video || videos.generic_hockey.videoUrl,
    staticAnnotation: props.staticAnnotation,
    title: matchTitle || props.title,
    subtitle: matchTitle ? (isCountdownNoSubtitle ? null : props.subtitle) : props.subtitle,
    customNetworks: props.customNetworks || ['fanduelsports'],
    sportId: sportIds.Hockey,
    leagueId: leagueIds.NHL,
    platformImage: devicePosters.nhl,
    countdownTimer: matchCountdownTimer,
    matchtickerSportId: sportIds.Hockey,
    matchtickerLeagueName: 'NHL',
    matchtickerLeagueId: leagueIds.NHL,
  }
  return showFDPlanCards ? (
    <StyledContainer isCountdown={isCountdown}>
      <FuboFreeTemplate
        {...commonProps}
        hasFanduelPlanCards={showFDPlanCards}
        fanduelRSNData={rsnData}
        additionalFAQs={fanduelSportsNetworkFAQs}
        {...props}
        title={matchTitle || props.title}
        subtitle={matchTitle ? (isCountdownNoSubtitle ? null : props.subtitle) : props.subtitle}
      />
    </StyledContainer>
  ) : (
    <StyledContainer isCountdown={isCountdown}>
      <USTemplateDefault
        {...commonProps}
        {...props}
        networkSet="hockey"
        title={matchTitle || props.title}
        subtitle={matchTitle ? (isCountdownNoSubtitle ? null : props.subtitle) : props.subtitle}
      />
    </StyledContainer>
  )
}

export default BallySportsNHL

const StyledContainer = styled.div`
  ${({ isCountdown }) =>
    isCountdown &&
    `
    .content-container .hero-content {
      max-width: 800px;
    }
    `}
`
